import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/promoting-ebay-listings';

export default function Example() {
  return (
    <>
      <Head>
        <title>Promote Your eBay Listings on Social Media</title>
        <meta
          name='description'
          content='Empower your business and drive traffic to your eBay listings using social media and increase your conversions. Learn how you can take advantage of social media and how it works.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/promoting-ebay-listings' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/promoting-ebay-listings' />
        <meta property='og:title' content='Promote Your eBay Listings on Social Media' />
        <meta
          property='og:description'
          content='Empower your business and drive traffic to your eBay listings using social media and increase your conversions. Learn how you can take advantage of social media and how it works.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
